"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUrlService = void 0;
const definition_1 = require("@wix/viewer-service-environment/definition");
const utils_1 = require("./utils");
const createUrlService = (config, getService) => {
    const { logger, currentRouteInfo, requestUrl, externalBaseUrl, queryParamsWhitelist } = config;
    const browserWindow = globalThis.window;
    const environmentService = getService(definition_1.EnvironmentDefinition);
    const isUpdateHrefInSafariIncognitoOpen = environmentService.isExperimentOpen('specs.thunderbolt.update_href_in_safari_incognito');
    const getCurrentUrl = () => browserWindow?.location.href || requestUrl;
    let samePageUrlChangeListeners = [];
    const state = {};
    const pushUrl = (_parsedUrl, { disableScrollToTop, skipHistory } = {}) => {
        if (!browserWindow || !browserWindow.history) {
            return;
        }
        const currentUrl = new URL(getCurrentUrl());
        const parsedUrl = (0, utils_1.applyRetainedQueryParams)(currentUrl, _parsedUrl.href, queryParamsWhitelist);
        const url = parsedUrl.toString();
        parsedUrl.searchParams.sort();
        currentUrl.searchParams.sort();
        const historyState = { scrollY: browserWindow.scrollY };
        if (skipHistory) {
            browserWindow.history.replaceState(historyState, '', url);
        }
        if (currentUrl.toString() === parsedUrl.toString()) {
            return;
        }
        if (!skipHistory) {
            browserWindow.history.replaceState(historyState, '', currentUrl.toString());
            try {
                const data = disableScrollToTop ? { scrollY: historyState?.scrollY } : null;
                browserWindow.history.pushState(data, '', url);
                // Safari in incognito + reaching a site indirectly (from google for example) doesn't update window.location.href correctly.
                // Query params are not updated
                if (isUpdateHrefInSafariIncognitoOpen && (0, utils_1.isSafari)(window) && url !== window.location.href) {
                    window.location.href = url;
                }
            }
            catch (error) {
                logger?.captureError(error, { tags: { feature: 'feature-router', pushStateError: true } });
            }
        }
        const currentPageId = currentRouteInfo?.getCurrentRouteInfo()?.pageId;
        if (state.previousPageId === currentPageId) {
            samePageUrlChangeListeners.forEach(listener => listener.onUrlChange(new URL(url)));
        }
    };
    const api = {
        getHistoryState: () => {
            if (!browserWindow || !browserWindow.history) {
                return null;
            }
            return browserWindow.history.state;
        },
        updateHistoryState: (newHistory) => {
            if (!browserWindow || !browserWindow.history) {
                return;
            }
            if (newHistory) {
                const currentUrl = new URL(browserWindow.location.href);
                currentUrl.searchParams.sort();
                browserWindow.history.replaceState(newHistory, '', currentUrl.toString());
            }
        },
        getParsedUrl: () => new URL(api.getCurrentUrl()),
        getRelativeUrl: () => (0, utils_1.getRelativeUrl)(api.getCurrentUrl(), externalBaseUrl),
        getRelativeEncodedUrl: () => (0, utils_1.getRelativeEncodedUrl)(api.getCurrentUrl(), externalBaseUrl),
        updateState: (pageId) => {
            state.previousPageId = pageId;
        },
        addOnUrlChangeListener: (listenerToAdd) => {
            samePageUrlChangeListeners.push(listenerToAdd);
        },
        removeOnUrlChangeListener: (listenerToRemove) => {
            samePageUrlChangeListeners = samePageUrlChangeListeners.filter(listener => listener !== listenerToRemove);
        },
        getFullUrlWithoutQueryParams: () => {
            const relativeUrl = api.getRelativeUrl();
            const isHomePageUrl = relativeUrl === './';
            const replaceStr = isHomePageUrl ? externalBaseUrl : `${externalBaseUrl}/`;
            return relativeUrl.replace('./', replaceStr);
        },
        pushUrl,
        getCurrentUrl,
        getExternalBaseUrl: () => externalBaseUrl,
    };
    return api;
};
exports.createUrlService = createUrlService;
//# sourceMappingURL=createUrlService.js.map